import React from "react";

const PricingAtAGlance = () => {
  return (
    <section className="bg-[#D7F3EF] py-20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">

          {/* Left Card */}
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <h3 className="text-lg font-semibold text-[#0F172A] mb-6">
              Pricing at a glance
            </h3>

            <ul className="space-y-4">
              <PricingRow label="Advance rate" value="Up to 90%" />
              <PricingRow label="Typical monthly cost" value="1.0–2.2%" />
              <PricingRow label="Setup & onboarding" value="$0" />
              <PricingRow label="Minimum commitment" value="None" />
              <PricingRow label="Settlement" value="Automatic" />
            </ul>
          </div>

          {/* Right Card */}
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <h3 className="text-lg font-semibold text-[#0F172A] mb-6">
              Which option fits best?
            </h3>

            <ul className="space-y-4 mb-8">
              <PricingRow label="Invoice volume" value="Low / Medium / High" />
              <PricingRow label="Payment terms" value="Net 15–90" />
              <PricingRow label="Buyer mix" value="Single or multi-buyer" />
              <PricingRow label="Industry risk" value="A–C tiers" />
            </ul>

            <button className="bg-[#00B3A4] text-white text-sm font-semibold px-4 py-2.5 rounded-md hover:bg-[#009688] transition">
              Get custom quote
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

const PricingRow = ({ label, value }) => (
  <li className="flex justify-between items-center border-b border-[#E2E8F0] pb-3 text-sm">
    <span className="text-[#64748B]">{label}</span>
    <span className="text-[#0F172A] font-medium">{value}</span>
  </li>
);

export default PricingAtAGlance;
